module.exports = __webpack_public_path__ + "img/_0.42c0fb66.png";